// extracted by mini-css-extract-plugin
export default {"onboardingForm":"OnboardingForm_onboardingForm__Hauh7"};